import { useEffect, useState } from 'react';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Necesito experiencia previa para tomar este curso?',
      answer: 'No, absolutamente no. El curso está diseñado desde cero para principiantes. Te guiamos paso a paso desde lo más básico hasta estrategias avanzadas. Solo necesitas ganas de aprender y una computadora con internet.'
    },
    {
      question: '¿Cuánto tiempo tengo acceso al contenido?',
      answer: 'Tienes acceso de por vida. Una vez que te inscribes, el contenido es tuyo para siempre. Además, recibirás todas las actualizaciones futuras sin costo adicional.'
    },
    {
      question: '¿Qué métodos de pago aceptan?',
      answer: 'Aceptamos múltiples métodos de pago: tarjetas de crédito/débito, transferencias bancarias, Yape, Plin y PayPal. Puedes elegir el que más te convenga.'
    },
    {
      question: '¿Cuánto tiempo necesito dedicar al día?',
      answer: 'Recomendamos dedicar al menos 1-2 horas diarias para ver resultados más rápidos. Sin embargo, el curso es 100% a tu ritmo, puedes avanzar según tu disponibilidad.'
    },
    {
      question: '¿Tienen garantía de devolución?',
      answer: 'Sí, ofrecemos garantía de satisfacción. Si dentro de los primeros 30 días sientes que el curso no es para ti, te devolvemos tu dinero sin preguntas.'
    },
    {
      question: '¿Puedo acceder desde mi celular?',
      answer: 'Sí, nuestra plataforma es 100% responsive. Puedes ver las clases desde tu computadora, tablet o celular en cualquier momento y lugar.'
    },
    {
      question: '¿Qué soporte recibo si tengo dudas?',
      answer: 'Tienes acceso a nuestra comunidad privada en Skool y Telegram donde puedes hacer preguntas 24/7. Además, realizamos clases en vivo mensuales donde resolvemos dudas en tiempo real.'
    },
    {
      question: '¿Cuándo empiezo a ver resultados?',
      answer: 'Depende de tu dedicación, pero muchos de nuestros estudiantes empiezan a ver sus primeras ventas en las primeras 2-4 semanas aplicando las estrategias del curso.'
    }
  ];

  useEffect(() => {
    // Scroll to section if hash exists
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 py-12 sm:py-16 lg:py-20">
        <div className="absolute inset-0 opacity-5">
          <img
            alt=""
            className="w-full h-full object-cover object-center mix-blend-screen"
            src="https://public.readdy.ai/ai/img_res/0f97b7b948d087c5be562f84f625881a.jpg"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 lg:w-96 lg:h-96 bg-yellow-400/10 rounded-full blur-3xl -top-16 -left-16 sm:-top-24 sm:-left-24 md:-top-32 md:-left-32 lg:-top-48 lg:-left-48 animate-pulse"></div>
          <div className="absolute w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 lg:w-96 lg:h-96 bg-emerald-400/10 rounded-full blur-3xl -bottom-16 -right-16 sm:-bottom-24 sm:-right-24 md:-bottom-32 md:-right-32 lg:-bottom-48 lg:-right-48 animate-pulse"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 w-full">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="space-y-6">
              <div className="text-center lg:text-left mb-6">
                <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white mb-4 drop-shadow-lg leading-tight uppercase">
                  COPIA MI SISTEMA <span className="text-yellow-400">SCALEUP</span>: VENDE{' '}
                  <span className="text-yellow-400">PRODUCTOS DIGITALES</span> EN AUTOMÁTICO CON{' '}
                  <span className="text-yellow-400">IA</span>
                </h1>
                <p className="text-xs sm:text-sm lg:text-base text-white leading-relaxed drop-shadow-md">
                  La estrategia 2026 para vender PDFs, Descargables y Herramientas usando WhatsApp y escalando con VSL y Paginas de alta convercion , sin bloqueos de Facebook y sin experiencia técnica 🚀
                </p>
              </div>

              <div className="relative w-full">
                <div className="absolute -inset-0.5 sm:-inset-1 md:-inset-2 lg:-inset-4 bg-gradient-to-r from-yellow-400 via-emerald-400 to-teal-400 rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-3xl blur-md sm:blur-lg md:blur-xl opacity-75 animate-pulse"></div>
                <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-md sm:rounded-lg md:rounded-xl lg:rounded-2xl p-0.5 md:p-1 lg:p-2 shadow-2xl">
                  <div className="relative bg-gradient-to-br from-yellow-400/20 via-emerald-400/20 to-teal-400/20 rounded-md sm:rounded-lg md:rounded-xl p-0.5 md:p-1">
                    <div className="relative bg-black rounded-md sm:rounded-lg overflow-hidden shadow-inner">
                      <div className="absolute top-1.5 right-1.5 sm:top-2 sm:right-2 md:top-3 md:right-3 lg:top-4 lg:right-4 z-20 bg-red-600/95 backdrop-blur-sm rounded-full px-1.5 py-0.5 sm:px-2 sm:py-1 md:px-3 md:py-1.5 lg:px-4 lg:py-2 flex items-center gap-1 sm:gap-1.5 md:gap-2 shadow-lg">
                        <div className="relative flex items-center justify-center w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-2.5 lg:h-2.5">
                          <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping"></span>
                          <span className="relative inline-flex rounded-full h-1 w-1 sm:h-1.5 sm:w-1.5 md:h-2 md:w-2 lg:h-2.5 lg:w-2.5 bg-red-500"></span>
                        </div>
                        <span className="text-white font-semibold text-[10px] sm:text-xs md:text-sm whitespace-nowrap">45 viendo</span>
                      </div>

                      <div className="absolute top-0 left-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-t border-l sm:border-t-2 sm:border-l-2 md:border-t-2 md:border-l-2 lg:border-t-4 lg:border-l-4 border-yellow-400 rounded-tl-md sm:rounded-tl-lg z-10"></div>
                      <div className="absolute top-0 right-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-t border-r sm:border-t-2 sm:border-r-2 md:border-t-2 md:border-r-2 lg:border-t-4 lg:border-r-4 border-emerald-400 rounded-tr-md sm:rounded-tr-lg z-10"></div>
                      <div className="absolute bottom-0 left-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-b border-l sm:border-b-2 sm:border-l-2 md:border-b-2 md:border-l-2 lg:border-t-4 lg:border-l-4 border-teal-400 rounded-bl-md sm:rounded-bl-lg z-10"></div>
                      <div className="absolute bottom-0 right-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-b border-r sm:border-b-2 sm:border-r-2 md:border-b-2 md:border-r-2 lg:border-b-4 lg:border-r-4 border-yellow-400 rounded-br-md sm:rounded-br-lg z-10"></div>

                      <div className="hidden md:block absolute top-1/2 left-0 w-1 h-24 bg-gradient-to-b from-transparent via-yellow-400 to-transparent transform -translate-y-1/2 animate-pulse"></div>
                      <div className="hidden md:block absolute top-1/2 right-0 w-1 h-24 bg-gradient-to-b from-transparent via-emerald-400 to-transparent transform -translate-y-1/2 animate-pulse"></div>

                      <div className="relative w-full aspect-video bg-gray-900">
                        <iframe
                          src="https://player.vimeo.com/video/1158891827?badge=0&autopause=0&player_id=0&app_id=58479"
                          frameBorder={0}
                          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                          title="Video de presentación"
                          className="w-full h-full"
                        ></iframe>
                      </div>

                      <div className="absolute -bottom-0.5 md:-bottom-1 lg:-bottom-2 left-1/2 transform -translate-x-1/2 w-3/4 h-0.5 md:h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent rounded-full"></div>
                    </div>

                    <div className="absolute -top-0.5 -left-0.5 sm:-top-1 sm:-left-1 md:-top-2 md:-left-2 lg:-top-4 lg:-left-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-yellow-400 rounded-full animate-ping"></div>
                    <div className="absolute -top-0.5 -right-0.5 sm:-top-1 sm:-right-1 md:-top-2 md:-right-2 lg:-top-4 lg:-right-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-emerald-400 rounded-full animate-ping"></div>
                    <div className="absolute -bottom-0.5 -left-0.5 sm:-bottom-1 sm:-left-1 md:-bottom-2 md:-left-2 lg:-bottom-4 lg:-left-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-teal-400 rounded-full animate-ping"></div>
                    <div className="absolute -bottom-0.5 -right-0.5 sm:-bottom-1 sm:-right-1 md:-bottom-2 md:-right-2 lg:-bottom-4 lg:-right-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-yellow-400 rounded-full animate-ping"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6 sm:space-y-8">
              <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
                <span className="text-xl sm:text-2xl">🔥</span>
                <span className="text-white text-xs sm:text-sm font-medium">Oferta de Lanzamiento - Solo por Tiempo Limitado</span>
              </div>

              <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-extrabold text-white leading-tight">
                ¡CONVIÉRTETE EN UN EXPERTO EN{' '}
                <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                  TRÁFICO Y VENTAS DIGITALES!
                </span>
              </h2>

              <p className="text-sm sm:text-base lg:text-lg text-white/80 leading-relaxed">
                Aprende estrategias comprobadas para vender productos online TODOS LOS DÍAS con publicidad pagada, incluso si estás empezando desde cero.
              </p>

              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-xs sm:text-sm lg:text-base">
                    Vender productos digitales utilizando la inteligencia artificial
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-xs sm:text-sm lg:text-base">
                    El paso a paso desde cero para poder generar ingresos todos los meses y en tiempo récord
                  </span>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-white text-xs sm:text-sm lg:text-base">
                    Escalar tus resultados mes a mes con una metodología comprobada por nuestros alumnos
                  </span>
                </div>
              </div>

              <div className="flex flex-wrap justify-center gap-4 sm:gap-6 lg:gap-8 pt-4">
                <div className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">500+</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Estudiantes</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white flex items-center gap-1 justify-center">
                    4.9 <i className="ri-star-fill text-yellow-400 text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Rating</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white whitespace-nowrap">30 días</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Garantía</div>
                </div>
              </div>

              <div className="relative hidden lg:block mt-8">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:rotate-2 transition-transform duration-500">
                  <img
                    alt="Dashboard"
                    className="w-full h-auto object-cover"
                    src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/ed8f4c70da48f615e6a248f14a7f4fba.png"
                  />
                </div>
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full blur-2xl opacity-60 animate-pulse"></div>
                <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full blur-2xl opacity-40 animate-pulse"></div>
                <div className="absolute top-4 -left-3 bg-yellow-400 text-gray-900 px-3 py-1.5 rounded-lg font-bold shadow-xl transform -rotate-6 text-sm whitespace-nowrap">
                  ✨ Resultados Reales
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="relative space-y-6">
                <div className="relative rounded-3xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
                  <img
                    alt="Resultados"
                    className="w-full h-64 object-cover object-top"
                    src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/4e6536156e166d60d05604d3f00dbb09.jpeg"
                  />
                </div>
                <div className="relative rounded-3xl overflow-hidden shadow-2xl ml-12 transform hover:scale-105 transition-transform duration-500">
                  <img
                    alt="Estudiante"
                    className="w-full h-80 object-cover object-top"
                    src="https://public.readdy.ai/ai/img_res/31f91335232853b30d11acaead9e0afb.jpg"
                  />
                </div>
                <div className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-yellow-400 text-gray-900 px-6 py-3 rounded-xl font-bold shadow-2xl whitespace-nowrap">
                  ✨ Resultados Reales
                </div>
              </div>
            </div>

            <div className="space-y-8">
              <div className="space-y-4">
                <div className="flex items-center gap-2 text-emerald-600 font-semibold text-sm uppercase tracking-wider">
                  <div className="w-2 h-2 rounded-full bg-emerald-600"></div>
                  Por Qué Elegirnos
                </div>
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                  ¿Por qué esta academia es diferente? 🎯
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Sabemos que hoy no basta con publicar contenido — lo que realmente convierte son anuncios inteligentes, funnels efectivos y estrategias que venden y aprovechan la inteligencia artificial para acelerar el proceso
                </p>
              </div>

              <div className="grid sm:grid-cols-2 gap-6">
                <div className="p-6 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-rocket-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Campañas que Venden</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Crea anuncios inteligentes que generan ventas desde el inicio
                  </p>
                </div>

                <div className="p-6 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-whatsapp-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Venta por WhatsApp</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Aprende a vender efectivamente sin perder dinero
                  </p>
                </div>

                <div className="p-6 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-flow-chart text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Escalar con VSL y Páginas web de alta conversión</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Diseña embudos de venta + VSL que realmente convierten hechos con plataformas de inteligencia artificial como LOVABLE o READDY
                  </p>
                </div>

                <div className="p-6 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <i className="ri-user-star-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Nuestra metodología está validada</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Con nuestra metodología vas a tener resultados todos los meses todos los días toda la semana
                  </p>
                </div>
              </div>

              <p className="text-lg text-gray-700 font-medium">
                No necesitas conocimientos previos. Todo está estructurado para que puedas aplicar desde el primer día.
              </p>

              <a
                href="https://wa.link/qv7d6a"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-emerald-600 font-semibold hover:gap-4 transition-all cursor-pointer"
              >
                Conoce nuestra metodología completa
                <i className="ri-arrow-right-line"></i>
              </a>

              <div className="flex gap-12 pt-4">
                <div>
                  <div className="text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
                    100%
                  </div>
                  <div className="text-gray-600 text-sm mt-1 whitespace-nowrap">Práctico</div>
                </div>
                <div>
                  <div className="text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
                    24/7
                  </div>
                  <div className="text-gray-600 text-sm mt-1 whitespace-nowrap">Soporte</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="cursos" className="py-24 bg-gradient-to-br from-slate-50 via-purple-50 to-cyan-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">Qué incluye tu acceso</h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Acceso completo a todos los cursos y soporte que necesitas para comenzar a vender desde el primer día
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer bg-white">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Estrategias Publicitarias Avanzadas"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src="https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/5b48623fddede62d80f792b21cc2f915.jpeg"
                />
                <div className="absolute top-4 left-4 px-4 py-1.5 rounded-full text-sm font-bold whitespace-nowrap bg-gradient-to-r from-emerald-500 to-cyan-500 text-white">
                  Facebook Ads
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">Estrategias Publicitarias Avanzadas</h3>
                <div className="flex items-center gap-2 text-emerald-600">
                  <i className="ri-play-circle-line text-xl"></i>
                  <span className="text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>

            <div className="group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer bg-white">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Venta por WhatsApp"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src="https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/35e796b5b6727cd830e10b20f159531c.jpeg"
                />
                <div className="absolute top-4 left-4 px-4 py-1.5 rounded-full text-sm font-bold whitespace-nowrap bg-gradient-to-r from-emerald-500 to-cyan-500 text-white">
                  Conversión
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">Venta por WhatsApp</h3>
                <div className="flex items-center gap-2 text-emerald-600">
                  <i className="ri-play-circle-line text-xl"></i>
                  <span className="text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>

            <div className="group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer bg-white">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Embudos y VSL y Páginas de Alta Conversión"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src="https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/95c097ee04be1553a1ddc69469677698.jpeg"
                />
                <div className="absolute top-4 left-4 px-4 py-1.5 rounded-full text-sm font-bold whitespace-nowrap bg-gradient-to-r from-emerald-500 to-cyan-500 text-white">
                  Funnels
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">Embudos y VSL y Páginas de Alta Conversión</h3>
                <div className="flex items-center gap-2 text-emerald-600">
                  <i className="ri-play-circle-line text-xl"></i>
                  <span className="text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>

            <div className="group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer bg-gradient-to-br from-gray-900 to-slate-800">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Clases en VIVO"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src="https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/9fc0135a95f2545edfcc07ab4d96091f.jpeg"
                />
                <div className="absolute top-4 left-4 px-4 py-1.5 rounded-full text-sm font-bold whitespace-nowrap bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900">
                  Exclusivo
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-white">Clases en VIVO</h3>
                <div className="flex items-center gap-2 text-emerald-400">
                  <i className="ri-play-circle-line text-xl"></i>
                  <span className="text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>

            <div className="group rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer bg-white">
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Comunidad Privada"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src="https://static.readdy.ai/image/40f51af0b69eb90de3a0845494d055fd/ce2ff3d164cf4b73b18d219ecc44858b.jpeg"
                />
                <div className="absolute top-4 left-4 px-4 py-1.5 rounded-full text-sm font-bold whitespace-nowrap bg-gradient-to-r from-emerald-500 to-cyan-500 text-white">
                  Soporte 24/7
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900">Comunidad Privada</h3>
                <div className="flex items-center gap-2 text-emerald-600">
                  <i className="ri-play-circle-line text-xl"></i>
                  <span className="text-sm font-medium whitespace-nowrap">Acceso inmediato</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 grid md:grid-cols-4 gap-8">
            <div className="flex items-center gap-4 p-6 rounded-2xl bg-white shadow-md">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-refresh-line text-white text-2xl"></i>
              </div>
              <span className="text-gray-900 font-semibold">Actualizaciones constantes</span>
            </div>

            <div className="flex items-center gap-4 p-6 rounded-2xl bg-white shadow-md">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-tools-line text-white text-2xl"></i>
              </div>
              <span className="text-gray-900 font-semibold">Acceso de inmediato y de por Vida</span>
            </div>

            <div className="flex items-center gap-4 p-6 rounded-2xl bg-white shadow-md">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-medal-line text-white text-2xl"></i>
              </div>
              <span className="text-gray-900 font-semibold">Soporte de por vida por nuestra comunidad en skool y telegram</span>
            </div>
          </div>

          <div className="mt-16 text-center">
            <p className="text-2xl font-bold text-gray-900 mb-2">
              Puedes acceder desde <span className="text-emerald-600">S/70 De por vida</span>
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">Beneficios clave</h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Transforma tu conocimiento en una fuente de ingresos constante
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-shield-flash-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Tráfico Pro Élite (Anti-Bloqueos)</h3>
              <p className="text-gray-600 leading-relaxed">
                La estructura exacta de campañas que uso para evitar bloqueos y conseguir clientes a bajo costo
              </p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>

            <div className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-message-3-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Cierre de Ventas Semiautomático</h3>
              <p className="text-gray-600 leading-relaxed">
                Guiones de ChatGPT y BotConversa probados para que los clientes te pidan comprar a ti
              </p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>

            <div className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-rocket-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Tu Máquina de Ventas 24/7</h3>
              <p className="text-gray-600 leading-relaxed">
                Plantillas listas para usar en Lovable/Readdy. Clona mi negocio en minutos
              </p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>

            <div className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-user-star-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Mentores con experiencia</h3>
              <p className="text-gray-600 leading-relaxed">
                Aprende de expertos en ventas digitales de nuestra comunidad
              </p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>

            <div className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-money-dollar-circle-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Recupera tu inversión rápido</h3>
              <p className="text-gray-600 leading-relaxed">
                Resultados en tiempo récord con nuestra metodología
              </p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>

            <div className="group p-8 rounded-2xl bg-gradient-to-br from-white to-gray-50 border-2 border-gray-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-shield-check-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Garantía de satisfacción</h3>
              <p className="text-gray-600 leading-relaxed">garantia de por vida</p>
              <div className="mt-4 flex items-center gap-2 text-emerald-600 font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm whitespace-nowrap">Más información</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center p-12 rounded-3xl bg-gradient-to-r from-emerald-50 to-cyan-50 border-2 border-emerald-200">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">¿Listo para comenzar tu transformación digital?</h3>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Únete a cientos de estudiantes que ya están generando ingresos con nuestras estrategias probadas
            </p>
          </div>
        </div>
      </section>

      {/* Mentor Section */}
      <section className="relative py-16 sm:py-20 lg:py-24 bg-white overflow-hidden">
        <div className="absolute top-20 right-0 w-64 h-64 bg-gradient-to-br from-emerald-400/20 to-cyan-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-br from-emerald-500/10 to-cyan-500/10 rounded-full blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="relative order-2 lg:order-1">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  alt="Esaul Lorenzo"
                  className="w-full h-auto object-cover"
                  src="https://static.readdy.ai/image/45eab4418adfae5cd9f32d2f060296c0/2b71e9ac5881b1b0a3522106f65a8458.png"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-gradient-to-r from-emerald-500 to-cyan-500 text-white px-6 py-4 rounded-2xl shadow-2xl transform rotate-3">
                <div className="text-3xl font-bold">10+</div>
                <div className="text-sm font-medium whitespace-nowrap">Años de Experiencia</div>
              </div>
            </div>

            <div className="space-y-6 order-1 lg:order-2">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-100 to-cyan-100 border border-emerald-200">
                <i className="ri-user-star-line text-emerald-600 text-xl"></i>
                <span className="text-emerald-700 text-sm font-semibold whitespace-nowrap">Tu Mentor</span>
              </div>

              <div className="space-y-4">
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight">
                  Soy <span className="bg-gradient-to-r from-emerald-500 to-cyan-500 bg-clip-text text-transparent">Esaul</span>
                </h2>

                <div className="space-y-4 text-base sm:text-lg text-gray-700 leading-relaxed">
                  <p>
                    Tengo <strong className="text-gray-900">10 años dedicado al comercio online</strong> y desde hace{' '}
                    <strong className="text-gray-900">más de 3 años me dedico a la venta de productos digitales</strong>.
                  </p>
                  <p>
                    He ayudado a <strong className="text-emerald-600">muchos emprendedores a generar ingresos</strong> y mi objetivo es ayudarte a{' '}
                    <strong className="text-emerald-600">vivir de este negocio</strong>.
                  </p>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4 pt-6">
                <div className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">10</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Años Online</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white flex items-center gap-1 justify-center">
                    3+ <i className="ri-star-fill text-yellow-400 text-lg sm:text-xl lg:text-2xl"></i>
                  </div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Años Digitales</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white whitespace-nowrap">500+</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Estudiantes</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Academy Skool Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-violet-900 via-purple-800 to-indigo-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
              <i className="ri-community-line text-cyan-400 text-xl"></i>
              <span className="text-white text-sm font-semibold whitespace-nowrap">Comunidad Exclusiva</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">
              En Nuestra Academia en <span className="text-cyan-400">Skool</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
              Únete a una comunidad vibrante donde aprenderás, compartirás y crecerás junto a otros emprendedores digitales
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/20">
                <img
                  src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/28de21a3a21dde0969438230dac74617.png"
                  alt="Academia Skool - Módulos del curso de productos digitales"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="space-y-6">
              <div className="grid sm:grid-cols-2 gap-4">
                <div className="p-5 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center flex-shrink-0">
                      <i className="ri-group-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-base mb-1">Comunidad Activa 24/7</h3>
                      <p className="text-white/70 text-sm leading-relaxed">Conecta con emprendedores que comparten tus mismos objetivos y desafíos</p>
                    </div>
                  </div>
                </div>

                <div className="p-5 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-base mb-1">Soporte Directo</h3>
                      <p className="text-white/70 text-sm leading-relaxed">Obtén respuestas rápidas de mentores y compañeros experimentados</p>
                    </div>
                  </div>
                </div>

                <div className="p-5 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center flex-shrink-0">
                      <i className="ri-trophy-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-base mb-1">Retos y Gamificación</h3>
                      <p className="text-white/70 text-sm leading-relaxed">Participa en desafíos semanales y gana recompensas por tu progreso</p>
                    </div>
                  </div>
                </div>

                <div className="p-5 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/15 transition-all sm:col-span-2">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center flex-shrink-0">
                      <i className="ri-live-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-base mb-1">Sesiones en Vivo</h3>
                      <p className="text-white/70 text-sm leading-relaxed">Clases exclusivas, Q&A y masterclasses con expertos del sector</p>
                    </div>
                  </div>
                </div>

                <div className="p-5 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/15 transition-all sm:col-span-2">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center flex-shrink-0">
                      <i className="ri-share-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-base mb-1">Comparte tus Resultados</h3>
                      <p className="text-white/70 text-sm leading-relaxed">Celebra tus victorias y aprende de las experiencias de otros miembros</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap justify-center lg:justify-start gap-6 sm:gap-8 pt-4">
                <div className="text-center">
                  <div className="text-3xl sm:text-4xl font-bold text-white">500+</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Miembros Activos</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl sm:text-4xl font-bold text-white">100+</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Posts Diarios</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl sm:text-4xl font-bold text-white">24/7</div>
                  <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Soporte</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="py-24 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <img
            alt=""
            className="w-full h-full object-cover object-center mix-blend-screen"
            src="https://public.readdy.ai/ai/img_res/788e4e68ab777c4ed94bfe1a17826648.jpg"
          />
        </div>
        <div className="absolute top-20 right-20 w-64 h-64 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full blur-3xl opacity-20"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full blur-3xl opacity-20"></div>

        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-12 space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-100 to-cyan-100 border border-emerald-200 mb-6">
              <i className="ri-community-line text-emerald-400 text-xl"></i>
              <span className="text-emerald-700 text-sm font-semibold whitespace-nowrap">Comunidad Exclusiva</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
              En Nuestra Academia en <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">Skool</span>
            </h2>
            <p className="text-xl text-white/80 leading-relaxed">
              Únete a una comunidad vibrante donde aprenderás, compartirás y crecerás junto a otros emprendedores digitales
            </p>
          </div>

          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
            <img
              src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/8bd12868882e39227fa44bcfea086767.png"
              alt="Testimonios de estudiantes exitosos facturando con productos digitales"
              className="w-full h-auto object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center p-6 rounded-2xl bg-white shadow-lg border border-emerald-100">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
              </div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">$2,366+</div>
              <p className="text-gray-600 text-sm">Ingresos generados por estudiantes en 7 días</p>
            </div>
            
            <div className="text-center p-6 rounded-2xl bg-white shadow-lg border border-emerald-100">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">100+</div>
              <p className="text-gray-600 text-sm">Ventas impulsivas logradas por la comunidad</p>
            </div>
            
            <div className="text-center p-6 rounded-2xl bg-white shadow-lg border border-emerald-100">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">24/7</div>
              <p className="text-gray-600 text-sm">Resultados compartidos en tiempo real</p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-emerald-50 via-cyan-50 to-teal-50 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-emerald-300/30 to-cyan-300/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-br from-teal-300/30 to-emerald-300/30 rounded-full blur-3xl"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-100 to-cyan-100 border border-emerald-200">
              <i className="ri-group-line text-emerald-600 text-xl"></i>
              <span className="text-emerald-700 text-sm font-semibold whitespace-nowrap">Prueba Social</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight">
              Únete a cientos de <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">emprendedores</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Que ya están facturando con productos digitales en nuestra comunidad de Skool
            </p>
          </div>

          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
            <img
              src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/8ca5f90324ca6e37270bf12133d16566.png"
              alt="Testimonios de estudiantes exitosos facturando con productos digitales"
              className="w-full h-auto object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center p-6 rounded-2xl bg-white shadow-lg border border-emerald-100">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
              </div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">$2,366+</div>
              <p className="text-gray-600 text-sm">Ingresos generados por estudiantes en 7 días</p>
            </div>
            
            <div className="text-center p-6 rounded-2xl bg-white shadow-lg border border-emerald-100">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">100+</div>
              <p className="text-gray-600 text-sm">Ventas impulsivas logradas por la comunidad</p>
            </div>
            
            <div className="text-center p-6 rounded-2xl bg-white shadow-lg border border-emerald-100">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">24/7</div>
              <p className="text-gray-600 text-sm">Resultados compartidos en tiempo real</p>
            </div>
          </div>
        </div>
      </section>

      {/* Students Community Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-emerald-50/50 via-teal-50/50 to-cyan-50/50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 rounded-3xl p-8 sm:p-12 lg:p-16 shadow-xl border border-emerald-100">
            <div className="text-center space-y-6">
              <div className="flex justify-center gap-1">
                <i className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl"></i>
                <i className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl"></i>
                <i className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl"></i>
                <i className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl"></i>
                <i className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl"></i>
              </div>
              
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900">
                Más de 500 estudiantes activos
              </h2>
              
              <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
                Nuestra comunidad está llena de emprendedores que están implementando estas estrategias y generando resultados reales. Comparten sus avances, se apoyan mutuamente y celebran sus victorias juntos.
              </p>
              
              <div className="grid grid-cols-3 gap-4 sm:gap-6 pt-6">
                <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-md">
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">500+</div>
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">Estudiantes Activos</p>
                </div>
                <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-md">
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">4.9</div>
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">Rating Promedio</p>
                </div>
                <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-md">
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">100%</div>
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">Satisfacción</p>
                </div>
              </div>
              
              <div className="pt-6">
                <a
                  href="https://wa.link/nf4z39"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-base sm:text-lg bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-500 text-gray-900 hover:shadow-2xl hover:shadow-yellow-500/60 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  Únete a la Comunidad Ahora
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-400/20 border border-yellow-400/30 mb-6">
              <i className="ri-gift-line text-yellow-400 text-xl"></i>
              <span className="text-yellow-400 font-bold text-sm sm:text-base">TODO LO QUE RECIBES HOY</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4">
              La Oferta Más <span className="text-yellow-400">Completa</span> del Mercado
            </h2>
            <p className="text-white/80 text-base sm:text-lg">Esto es lo que obtienes cuando te unes hoy</p>
          </div>

          <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-3xl p-6 sm:p-8 lg:p-12 border-2 border-white/20 shadow-2xl">
            <div className="space-y-6">
              <div className="flex items-center justify-between p-4 sm:p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all duration-300 group">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-graduation-cap-line text-white text-2xl sm:text-3xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-base sm:text-lg lg:text-xl">Curso Método ScaleUp</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <i className="ri-check-line text-emerald-400 text-sm"></i>
                      <span className="text-emerald-400 text-xs sm:text-sm">Incluido</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-white/60 line-through text-sm sm:text-base">Valor:</div>
                  <div className="text-yellow-400 font-bold text-xl sm:text-2xl lg:text-3xl">S/200</div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 sm:p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all duration-300 group">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-chat-3-line text-white text-2xl sm:text-3xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-base sm:text-lg lg:text-xl">Pack de Prompts de Ventas</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <i className="ri-check-line text-emerald-400 text-sm"></i>
                      <span className="text-emerald-400 text-xs sm:text-sm">Incluido</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-white/60 line-through text-sm sm:text-base">Valor:</div>
                  <div className="text-yellow-400 font-bold text-xl sm:text-2xl lg:text-3xl">S/100</div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 sm:p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all duration-300 group">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-layout-line text-white text-2xl sm:text-3xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-base sm:text-lg lg:text-xl">Plantillas de Embudos</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <i className="ri-check-line text-emerald-400 text-sm"></i>
                      <span className="text-emerald-400 text-xs sm:text-sm">Incluido</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-white/60 line-through text-sm sm:text-base">Valor:</div>
                  <div className="text-yellow-400 font-bold text-xl sm:text-2xl lg:text-3xl">S/400</div>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 sm:p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all duration-300 group">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-team-line text-white text-2xl sm:text-3xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-base sm:text-lg lg:text-xl">Acceso a Comunidad Skool</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <i className="ri-check-line text-emerald-400 text-sm"></i>
                      <span className="text-emerald-400 text-xs sm:text-sm">Incluido</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-white/60 line-through text-sm sm:text-base">Valor:</div>
                  <div className="text-yellow-400 font-bold text-xl sm:text-2xl lg:text-3xl">Invaluable</div>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t-2 border-white/20">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-center sm:text-left">
                  <div className="text-white/60 text-sm sm:text-base mb-1">Valor Total:</div>
                  <div className="text-white/40 line-through text-2xl sm:text-3xl lg:text-4xl font-bold">S/1000</div>
                </div>
                <div className="text-center sm:text-right">
                  <div className="text-yellow-400 text-sm sm:text-base mb-1 font-semibold">🔥 Precio de Hoy:</div>
                  <div className="text-5xl sm:text-6xl lg:text-7xl font-extrabold bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 bg-clip-text text-transparent animate-pulse">
                    S/70
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 rounded-2xl bg-gradient-to-r from-yellow-400/20 to-orange-400/20 border-2 border-yellow-400/30">
              <div className="flex items-start gap-3">
                <i className="ri-alarm-warning-line text-yellow-400 text-2xl mt-1"></i>
                <div>
                  <h4 className="text-white font-bold text-lg mb-2">⚡ Advertencia Importante</h4>
                  <p className="text-white/90 text-sm sm:text-base leading-relaxed">
                    Este precio de S/70 es solo para los primeros 50 estudiantes. Una vez que se llenen los cupos, el precio volverá a S/150 sin previo aviso. No pierdas esta oportunidad única.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Checkout Section */}
      <section id="checkout" className="relative py-16 sm:py-24 lg:py-32 overflow-hidden bg-gradient-to-br from-emerald-50 via-cyan-50 to-teal-50">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-emerald-300/30 to-cyan-300/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-teal-300/30 to-emerald-300/30 rounded-full blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-2xl mx-auto mb-8 sm:mb-12">
            <div className="bg-gradient-to-r from-red-500 via-orange-500 to-red-500 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl border-2 sm:border-4 border-white animate-pulse">
              <div className="text-center space-y-3 sm:space-y-4">
                <div className="flex items-center justify-center gap-1 sm:gap-2 mb-2">
                  <i className="ri-alarm-warning-line text-white text-xl sm:text-2xl lg:text-3xl"></i>
                  <h3 className="text-base sm:text-xl lg:text-2xl font-extrabold text-white">⚡ OFERTA EXPIRA EN:</h3>
                  <i className="ri-alarm-warning-line text-white text-xl sm:text-2xl lg:text-3xl"></i>
                </div>

                <div className="flex justify-center gap-2 sm:gap-3 lg:gap-4">
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 min-w-[70px] sm:min-w-[90px] lg:min-w-[120px] border border-white/30 sm:border-2">
                    <div className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-1 sm:mb-2">59</div>
                    <div className="text-white text-[10px] sm:text-xs lg:text-sm font-bold uppercase tracking-wider">Minutos</div>
                  </div>
                  <div className="flex items-center">
                    <span className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white">:</span>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 lg:p-6 min-w-[70px] sm:min-w-[90px] lg:min-w-[120px] border border-white/30 sm:border-2">
                    <div className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-1 sm:mb-2">52</div>
                    <div className="text-white text-[10px] sm:text-xs lg:text-sm font-bold uppercase tracking-wider">Segundos</div>
                  </div>
                </div>

                <div className="space-y-1 sm:space-y-2 pt-2">
                  <p className="text-white font-bold text-xs sm:text-base lg:text-lg">🔥 Solo quedan 7 cupos disponibles a este precio</p>
                  <p className="text-white/90 text-xs sm:text-sm lg:text-base">⚠️ Después de esto, el precio volverá a S/150</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-gray-900 mb-3 sm:mb-4 lg:mb-6 px-4">
              Comienza tu transformación{' '}
              <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">hoy mismo</span>
            </h2>
            <p className="text-sm sm:text-base lg:text-xl text-gray-600 leading-relaxed px-4">
              Acceso completo a todos los cursos, comunidad y actualizaciones
            </p>
          </div>

          <div className="flex justify-center max-w-2xl mx-auto px-4">
            <div className="relative rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 cursor-pointer transition-all duration-300 bg-gradient-to-br from-red-500 via-red-600 to-red-700 shadow-2xl hover:shadow-emerald-500/50 hover:scale-105 w-full">
              <div className="absolute -top-3 sm:-top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold whitespace-nowrap shadow-lg animate-pulse">
                🔥 MÁS POPULAR
              </div>

              <div className="text-center space-y-4 sm:space-y-6">
                <div>
                  <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 text-white">Acceso de Por Vida</h3>
                  <p className="text-xs sm:text-sm lg:text-base text-emerald-100">Pago único • Sin renovaciones</p>
                </div>

                <div className="py-4 sm:py-6">
                  <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2">
                    <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white/60 line-through">S/150</span>
                    <span className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white">S/70</span>
                  </div>
                  <p className="text-emerald-100 text-xs sm:text-sm lg:text-base">Pago único • Acceso ilimitado</p>
                </div>

                <ul className="space-y-3 sm:space-y-4 text-left">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-white text-sm sm:text-base lg:text-lg">Acceso a todos los cursos</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-white text-sm sm:text-base lg:text-lg">Actualizaciones de por vida</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-white text-sm sm:text-base lg:text-lg">Comunidad privada en Skool</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-white text-sm sm:text-base lg:text-lg">Clases en vivo mensuales</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-white text-sm sm:text-base lg:text-lg">Soporte 24/7</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-white text-sm sm:text-base lg:text-lg">Soporte de vida</span>
                  </li>
                </ul>

                <a
                  href="https://wa.link/nf4z39"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full px-4 sm:px-6 lg:px-8 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold text-xs sm:text-sm lg:text-lg xl:text-xl bg-gradient-to-r from-yellow-400 via-yellow-500 to-orange-500 text-gray-900 hover:shadow-2xl hover:shadow-yellow-500/60 transition-all hover:scale-110 shadow-xl shadow-yellow-500/40 cursor-pointer animate-pulse border-2 sm:border-4 border-white text-center leading-tight flex items-center justify-center gap-2"
                >
                  <i className="ri-whatsapp-line text-lg sm:text-xl lg:text-2xl"></i>
                  ACCEDER AHORA AL PRECIO DE OFERTA
                </a>

                <div className="mt-6 pt-6 border-t border-white/20">
                  <p className="text-white/80 text-sm text-center mb-4">Puedes pagar con:</p>
                  <div className="flex items-center justify-center gap-4 sm:gap-6">
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-[#6B2D83] flex items-center justify-center shadow-lg">
                        <span className="text-white font-bold text-lg sm:text-xl">Y</span>
                      </div>
                      <span className="text-white/80 text-xs sm:text-sm font-medium">Yape</span>
                    </div>
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-[#002A8D] flex items-center justify-center shadow-lg">
                        <span className="text-white font-bold text-sm sm:text-base">BCP</span>
                      </div>
                      <span className="text-white/80 text-xs sm:text-sm font-medium">BCP</span>
                    </div>
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-[#00D4AA] flex items-center justify-center shadow-lg">
                        <span className="text-gray-900 font-bold text-lg sm:text-xl">P</span>
                      </div>
                      <span className="text-white/80 text-xs sm:text-sm font-medium">Plin</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-100 to-cyan-100 border border-emerald-200 mb-6">
              <i className="ri-question-answer-line text-emerald-600 text-xl"></i>
              <span className="text-emerald-700 text-sm font-semibold whitespace-nowrap">Resolvemos tus dudas</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Preguntas <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">Frecuentes</span>
            </h2>
            <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
              Encuentra respuestas a las preguntas más comunes sobre nuestro programa
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`rounded-2xl border-2 transition-all duration-300 overflow-hidden ${
                  openFaq === index
                    ? 'border-emerald-300 bg-gradient-to-br from-emerald-50 to-cyan-50 shadow-lg'
                    : 'border-gray-200 bg-white hover:border-emerald-200 hover:shadow-md'
                }`}
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer"
                >
                  <span className={`font-bold text-base sm:text-lg transition-colors ${
                    openFaq === index ? 'text-emerald-700' : 'text-gray-900'
                  }`}>
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${
                    openFaq === index
                      ? 'bg-gradient-to-br from-emerald-500 to-cyan-500 rotate-180'
                      : 'bg-gray-100'
                  }`}>
                    <i className={`ri-arrow-down-s-line text-2xl ${
                      openFaq === index ? 'text-white' : 'text-gray-600'
                    }`}></i>
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${
                  openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-24 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 relative overflow-hidden">
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white mb-6">¿Listo para transformar tu vida?</h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Únete hoy y comienza a generar ingresos con productos digitales
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col items-center gap-6">
            <div className="text-center">
              <h3 className="text-white font-bold text-lg mb-4">Mis Redes Sociales</h3>
              <div className="flex items-center justify-center gap-6">
                <a
                  href="https://www.tiktok.com/@esaullorenzo.a"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-tiktok-line text-white text-2xl"></i>
                </a>
                <a
                  href="https://www.instagram.com/esaullorenzo/?hl=es"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-instagram-line text-white text-2xl"></i>
                </a>
                <a
                  href="https://www.youtube.com/@ESAULLORENZO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-youtube-line text-white text-2xl"></i>
                </a>
              </div>
            </div>
            <div className="text-white/60 text-sm text-center">
              © 2026 Método ScaleUp. Todos los derechos reservados.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
